import 'bootstrap/dist/css/bootstrap.min.css';


import Welcome from './Welcome';
//import Menu from './Menu.jsx';
//import Slider from './Slider.jsx';
import About from './About';
import Uses from './Uses';
import Contact from './Contact';



export default function Home() {
  return (
    <>
	  	<Welcome />
		  <br />
		  <br />
		  <Uses />
		  <br />
		  <br />
		  <br />
		  <About />
		  <br />
		  <Contact />
    </>
  );
}
